<template>
  <slot>
    <div :class="wrapperClasses" :id="identifier" v-show="!state.hidden">
      <label class="govuk-label" :for="controlId" v-show="!state.hiddenLabel" v-html="displayName"> </label>
      <span :id="titleId" class="govuk-title" v-html="displayTitle"></span>

      <div :class="displayHintClasses" v-if="displayHint" v-on:click="toggleHintSection" v-html="displayHintText"></div>
      <div :id="hintId" class="govuk-hint" v-show="!state.hiddenHint" v-html="displayHint"></div>

      <span :id="errorId" class="govuk-error-message">
        <ul v-if="currentErrors.length > 0">
          <li v-for="(errorMessage, errIndex) in currentErrors" v-bind:key="errIndex">
            {{ errorMessage.message }}
          </li>
        </ul>
      </span>
      <select class="govuk-select" :id="controlId" v-model="state.value" :disabled="state.readOnly">
        <template v-if="options">
          <option v-for="(option, index) in options" :key="index" :value="option.Value">
            {{ option.Text }}
          </option>
        </template>
      </select>
    </div>
  </slot>
</template>
<script lang="ts" src="@/library/templates/default/controls/ComboBox.ts"></script>
